
import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '../../../lib/models/User'

import BacModal from '@/components/BacModal.vue'
import BacTextarea from '@/components/BacTextarea.vue'
import BacButton from '@/components/BacButton.vue'
import { CustomerNote } from '../../../lib/models/CustomerNote'
import { DateUtils } from '../../../lib/utils/DateUtils'
import { Http } from '../../../lib/utils/Http'
import UIkit from 'uikit'

@Component({
  components: {
    BacModal,
    BacTextarea,
    BacButton
  }
})
export default class CustomerNoteModal extends Vue {
  @Prop({ default: () => new User() }) editedUser!: User;

  stagedNote = ''

  DateUtils = DateUtils

  async updateNotes () {
    await this.editedUser.updateNotes()
    UIkit.modal('#change-annotiation-modal').hide()
    UIkit.notification({
      message: 'Notizen erfolgreich gespeichert',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })

    this.$emit('save')
  }

  addNote () {
    const note = new CustomerNote()
    note.customerId = this.editedUser.id
    note.note = this.stagedNote;
    (note.createdAt as any) = new Date()
    this.editedUser.notes.push(note)

    this.stagedNote = ''
  }

  removeNote (i: number) {
    this.editedUser.notes.splice(i, 1)
  }
}
